<template>
  <v-app :dark="$vuetify.theme.dark" :light="!$vuetify.theme.dark">
    <core-app-bar />

    <core-drawer :image="bgMenu" :logo="logo" :links="menu"/>

    <core-view />

    <SnackBar/>
  </v-app>
</template>

<script>
  export default {
    data: () => ({
      logo: require('../assets/logo.png'),
      bgMenu: require('../assets/contabilidade.jpg'),
      menu: require('../config/menu.json')
    }),
    components: { 
      CoreDrawer: () => import('./core/Drawer'),
      CoreAppBar: () => import('./core/AppBar'),
      CoreView: () => import('./core/View'),
      SnackBar: () => import('./dialogs/Snackbar')
    }
  }
</script>
